import React from "react";
import { useTranslation } from "react-i18next";
import { Icon, type IconName } from "@local-logic/core/icons";
import * as Tab from "@radix-ui/react-tabs";
import { AVAILABLE_TABS } from "~/sdks/LocalDemographics/constants";
import { useRootElement } from "../context";
import * as styles from "./styles";

export const tabIcons: {
  [key: string]: IconName;
} = {
  income: "Wallet",
  population: "UsersFour",
  housing: "Buildings",
  household: "UsersThree",
  education: "GraduationCap",
  commute: "Path",
  languages: "Translate",
};

export const Tabs = () => {
  const { t } = useTranslation("localDemographics");
  const { options } = useRootElement();

  let activeCategories = AVAILABLE_TABS;

  if (options.omitTabs) {
    activeCategories = AVAILABLE_TABS.filter(
      (category) => !options.omitTabs?.includes(category),
    );
  }

  return (
    <Tab.List className={styles.tabsList} aria-label="Demographics tabs">
      {activeCategories.map((tab) => {
        const isActive = tab === options.activeTab;
        const triggerColor = isActive
          ? "--ll-color-primary"
          : "--ll-color-disabled";

        return (
          <React.Fragment key={tab}>
            <Tab.Trigger
              data-active={isActive}
              className={styles.trigger}
              value={tab}
            >
              <Icon icon={tabIcons[tab]} className={styles.icon} />
              <p className={styles.tabText}>{t(`data.${tab}.title`)}</p>
            </Tab.Trigger>
          </React.Fragment>
        );
      })}
    </Tab.List>
  );
};
